<template lang="pug">
.calendar.mt-4
  v-overlay(:value="loading" absolute)
    v-progress-circular(indeterminate)
  //- TODO rename
  c-header(
    :schedules="schedules"
    :current-date="currentDate"
    :type="type"
    @set-day="currentDate = $event"
    @set-type="type = $event"
    @set-filters="filterFields = $event"
  )
  .calendar-month(v-if="type === VIEW_TYPES.MONTH")
    c-week
    v-slide-x-transition(hide-on-leave)
      div(:key="Number(currentDate)")
        div.calendar-month--row(v-for="(row, i) in cells" :key="i")
          div.calendar-month--cell.pa-1(v-for="(cell, index) in row" :key="index")
            p.text-center.mb-0.subtitle-2 {{ cell.text }}
            v-card.white--text(
              @click="$router.push(`/tasks/${task.id}`)"
              v-if="checkDay(cell.text, task)"
              color="primary"
              v-for="(task, index) in tasks"
              :key="index"
            ).pa-2.mb-1 {{ task.name }}

</template>

<script>
import { mapGetters, mapActions  } from 'vuex';
import DialogAllSchedules from './components/DialogAllSchedules.vue';
import format from 'date-fns/format/index.js';
import CHeader from './components/CalendarHeader.vue';
import CWeek from './components/CalendarWeek.vue';
import { VIEW_TYPES } from './constants';
import EventForm from './components/EventForm.vue';
import {
  addWeeks, eachDayOfInterval, getDaysInMonth, nextMonday, subDays, isSameDay, //   subMonths, lastDayOfMonth
} from 'date-fns';
import { DAYS, MONTHS } from '@/constants';
import mixinDateTime from '@/mixins/mixinDateTime';

export default {
  components:{
    CHeader,
    CWeek,
    EventForm,
    DialogAllSchedules,
  },
  mixins:[mixinDateTime],
  props: {
    tasks: {
      type: [Array, Object, Boolean],
      required: true,
    },
  },
  data() {
    return {
      createDay:null,
      eventForm: false,

      // calendar
      type: VIEW_TYPES.MONTH,
      loading: false,
      currentDate: new Date(),
      filterFields: {},
      schedules: [],

      selectedDay: null,
      // constants
      DAYS,
      MONTHS,
      VIEW_TYPES,
    };
  },
  computed:{
    ...mapGetters({
      'isAdmin':'auth/isAdmin',
      'user': 'auth/getUser',
    }),
    hours() {
      // const from = 2;
      const to = 22;
      return Array.from({ length: to  / 4 }).map((_, index) => {
        const hour = (index + 1) * 4;
        if (hour < 10) return `0${hour}:00`;
        return `${hour}:00`;
      });
    },
    getFirstDateOfMonth() {
      return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth());
    },

    firstDayOfMonth() {
      return format(this.getFirstDateOfMonth, 'i');
    },

    weekDays() {
      const end  = subDays(addWeeks(this.currentDate, 1), 1);
      return eachDayOfInterval({ start: this.currentDate, end  });
    },
    cells() {
      const blanks = [];
      for (let i = 0; i < this.firstDayOfMonth - 1; i++) {
        blanks.push({ empty:true });
      }

      const daysInMonth = [];

      for (let d = 1; d <= getDaysInMonth(this.currentDate); d++) {
        daysInMonth.push({
          text: d,
          cell: true,
        });
      }
      const totalSlots = [...blanks, ...daysInMonth];
      const rows = [];
      let cells = [];

      totalSlots.forEach((row, i) => {
        if (i % 7 !== 0) {
          cells.push(row); // if index not equal 7 that means not go to next week
        } else {
          if (cells.length) {
            rows.push(cells); // when reach next week we contain all td in last week to rows
          }
          cells = []; // empty container
          cells.push(row); // in current loop we still push current row to new container
        }

        if (i === totalSlots.length - 1) {
          // when end loop we add remain date
          rows.push(cells);
        }
      });
      // render empty rest cells
      const restLength = rows[rows.length - 1].length;

      for (let i = 0; 7 - restLength > i; i++) {
        rows[rows.length - 1].push({ empty:true });
      }
      return rows;
    },
  },
  watch:{
    type(v) {
      if (v === VIEW_TYPES.WEEK) {
        this.currentDate = subDays(nextMonday(this.currentDate), 7);
      }
    },
  },
  methods: {
    ...mapActions({
      'loadToCache':'cache/loadToCache',
    }),
    scheduleColor(type) {
      return {
        1: 'accent',
        2:'primary',
      }[type] || 'info';
    },
    checkDay(day, task) {
      const calendarDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day);
      return isSameDay(new Date(task.notify_at), calendarDay);
    },
  },
};
</script>

<style lang="scss">
.calendar{
  position: relative;
}

.calendar-month {
  & {
    width: 100%;
    border-right: thin solid #c7c7c7;
    border-left: thin solid #c7c7c7;
    border-top: thin solid #c7c7c7;
    overflow: auto;
    border-radius: 5px;
  }

  &--row {
    display: flex;
    flex-direction: row;
    border-bottom: thin solid #c7c7c7;
  }

  &--cell {
    width: calc(100% / 7);
    height: auto;
    min-height: 100px;

    &:not(:nth-child(7n)){
      border-right: thin solid #c7c7c7;
    }

    &__add-btn {
      visibility: hidden;
    }

    &:hover {
      .calendar-month--cell__add-btn {
        visibility: initial;
      }
    }
  }

  &--event {
    border-radius: 5px;
  }
}

.calendar-week {
  & {
    width: 100%;
    border: thin solid #c7c7c7;
    overflow: auto;
    border-radius: 5px;
  }

  &--header {
    display: flex;
    flex-direction: row;

    &-cell {
      width: calc(100% / 7);
      min-width: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: thin solid #c7c7c7;

      & > div {
        padding: 10px;
        width: 100%;
      }

      &:not(:nth-child(8n)){
        border-right: thin solid #c7c7c7;
      }

      .header-cell__day {
        font-size: 3rem;
      }
    }
  }

}

</style>
